import { feature as topoToGeo } from "topojson-client";
import { sheetIdToUrl } from "../modules/google";

const convertTopoIfNeeded = (topologyObjectsName) => (json) => {
  return topologyObjectsName
    ? topoToGeo(json, json.objects[topologyObjectsName])
    : json;
};
const toJSON = (response) => response.json();
const fetchJson = (url) => fetch(url).then(toJSON);

export const getGeoJSON = (url, topologyObjectsName) => {
  return (dispatch) => {
    dispatch({ type: "GEOJSON:REQUEST" });
    return fetchJson(url)
      .then(convertTopoIfNeeded(topologyObjectsName))
      .then((geojson) =>
        dispatch({ type: "GEOJSON:SUCCESS", payload: geojson })
      )
      .catch((error) => dispatch({ type: "GEOJSON:FAILURE", payload: error }));
  };
};

const sheetId = "17XgLZWhNz5J0Kyr6BuEhcvLU1hkq6mAfaFBSBiWQgMY";
const sheetTabs = [
  "Accelerators",
  "Incubators",
  "R&D centres",
  "Coworking spaces",
  "Knowledge institutions",
];

export const getAllProjects = () => {
  return (dispatch) => {
    dispatch({ type: "PROJECT:ALL:REQUEST" });
    const promises = sheetTabs.map((tab) =>
      fetchJson(
        sheetIdToUrl(`${sheetId}?range='${encodeURIComponent(tab)}'!A1:H10000`)
      ).then((data) => {
        return {
          tab,
          data,
        };
      })
    );
    return Promise.all(promises)
      .then((dataForAllHubs) => {
        dispatch({
          type: "PROJECT:ALL:SUCCESS",
          payload: dataForAllHubs,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: "PROJECT:ALL:ERROR", payload: err });
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/data.js